import { Auth } from 'commons';


export default Auth;



// WEBPACK FOOTER //
// ./src/utils/Auth.js